import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Spinner } from "@chakra-ui/react";
export const Loading = () => (_jsx(Center, { children: _jsx(Spinner, { size: "xl", mt: 4 }, void 0) }, void 0));
